module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.c57ab803.woff2";